import React, { Fragment } from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function ManageCoupons() {
  const navigate = useNavigate();
  const coupons = [{
    id: 2006,
    code: '2006',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2007,
    code: '2007',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2008,
    code: '2008',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2009,
    code: '2009',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/01/2024',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2013,
    code: '2013',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: 'Not set',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2014,
    code: '2014',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2015,
    code: '2015',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2018,
    code: '2018',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/01/2024',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2019,
    code: '2019',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2021,
    code: '2021',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/11/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2022,
    code: '2022',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/12/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2023,
    code: '2023',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2024,
    code: '2024',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2025,
    code: '2025',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2029,
    code: '2029',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2031,
    code: '2031',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2033,
    code: '2033',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2034,
    code: '2034',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2037,
    code: '2037',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2039,
    code: '2039',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2040,
    code: '2040',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '05/21/2014',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2041,
    code: '2041',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '11/19/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2042,
    code: '2042',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '11/19/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2043,
    code: '2043',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2044,
    code: '2044',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2458,
    code: '2458',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/24/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2460,
    code: '2460',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/24/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2462,
    code: '2462',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '05/14/2020',
    limitations: 'All',
    exceed: 'no'
  }, {
    id: 2463,
    code: '2463',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '05/14/2020',
    limitations: 'All',
    exceed: 'no'
  }];
  return <div className="space-y-4" data-id="element-1114" data-mp="pa0pckjxmjgw">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1115" data-mp="pasmw0x3ar9t">Manage Coupons</h1>

      {/* Filters */}
      <div className="flex flex-wrap items-end gap-3" data-id="element-1116" data-mp="khzjbgdcxozb">
        <div data-id="element-1117" data-mp="fkzbp10v0e63">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1118" data-mp="fl904k69ad9o">Code</label>
          <input type="text" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1119" data-mp="al4nx6cds4p9" />
        </div>
        <div data-id="element-1120" data-mp="1k6gee2qhf1x">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1121" data-mp="1lpvw2gkfm2n">
            Discount Type
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1122" data-mp="3ssaty651fu96">
            <option data-id="element-1123" data-mp="1qzmnlnx3kqp6">All Types</option>
            <option data-id="element-1124" data-mp="1qzcsjlx73tcm">Percentage</option>
            <option data-id="element-1125" data-mp="1r0eamacmpg3u">Dollar</option>
          </select>
        </div>
        <div data-id="element-1126" data-mp="1yi42yarnmzq2">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1127" data-mp="1yim51o10085w">
            Usage Type
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-32" data-id="element-1128" data-mp="23gdwkgxqds9k">
            <option data-id="element-1129" data-mp="2d7rzyzsszc7z">All Usages</option>
            <option data-id="element-1130" data-mp="2d6qhwbdddpgr">General Use</option>
            <option data-id="element-1131" data-mp="1fk9j11ozn3sw">Per Customer</option>
          </select>
        </div>
        <div data-id="element-1132" data-mp="1fm45wljtl5zm">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1133" data-mp="1fmduc4p7v537">
            Limitations
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1134" data-mp="1kl7900g8p24y">
            <option data-id="element-1135" data-mp="1tl3rfkc1d4rk">All</option>
            <option data-id="element-1136" data-mp="1thy4aamywcyh">Single</option>
          </select>
        </div>
        <div data-id="element-1137" data-mp="30wkssne4p3yd">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1138" data-mp="30x2uw0nh2ce7">
            Exceed Amount
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-20" data-id="element-1139" data-mp="34xefjdfu4cpo">
            <option data-id="element-1140" data-mp="3m26o7l52w0nb">Any</option>
            <option data-id="element-1141" data-mp="3m2zkfs6ev7r7">Yes</option>
            <option data-id="element-1142" data-mp="3lzk8uzby4guj">No</option>
          </select>
        </div>
        <div data-id="element-1143" data-mp="4lyl83m1r416">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1144" data-mp="4mq7uoxo1rfb">Group</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-24" data-id="element-1145" data-mp="3vyt6c260sdln">
            <option data-id="element-1146" data-mp="dnobv783tyxw">All Groups</option>
            <option data-id="element-1147" data-mp="8njrv77zmm2x">PAR</option>
            <option data-id="element-1148" data-mp="8m8srkphm2i5">SAAR</option>
          </select>
        </div>
        <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1149" data-mp="nkawbuwiqnze">
          Search
        </Button>
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons/add')} data-id="element-1150" data-mp="2pc75wyz4lnrj">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1151" data-mp="14tddee21qhnf" />
          Add
        </Button>
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1152" data-mp="14v6ab1muxni8">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1153" data-mp="v17c2dpwmnvk" />
          Add PAR Coupon
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1154" data-mp="l5e2n37hfai0">
        <div className="overflow-x-auto" data-id="element-1155" data-mp="l6p7z7gksqb8">
          <table className="w-full text-sm text-left" data-id="element-1156" data-mp="764nm6v0imfm">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1157" data-mp="77fpu28t7m4m">
              <tr data-id="element-1158" data-mp="c5qzocz3twmu">
                <th className="px-3 py-3 border-r border-slate-700 w-8" data-id="element-1159" data-mp="c57r3mvcgklh">
                  <input type="checkbox" className="rounded border-slate-500" data-id="element-1160" data-mp="21knq49fk0pxn" />
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-20" data-id="element-1161" data-mp="26hnyiqzvm4rx">
                  Coupon Code
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-20" data-id="element-1162" data-mp="ikc1v0w53w01">
                  Discount Type
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-28" data-id="element-1163" data-mp="ne6fbml5jeqo">
                  Usage Type
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1164" data-mp="ejics46yob5k">
                  Discount Amount
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1165" data-mp="12a48qx3oy4z7">
                  Expire Date
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1166" data-mp="sbf3q4ww8f0d">
                  Limitations
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1167" data-mp="x9gkgj6uk28o">
                  Exceed Amount
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1168" data-mp="3d3qne9t3s27l">
                  <div data-id="element-1169" data-mp="3i1s44o323pfw">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1170" data-mp="3hyntb7v35vg9">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1171" data-mp="35hv2y6yhz5vk">
              {coupons.map(coupon => <tr key={coupon.id} className="hover:bg-slate-50" data-id="element-1172" data-mp="3jftihfok18cn">
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1173" data-mp="3ek4ft3h8nbc4">
                    <input type="checkbox" className="rounded border-slate-300" data-id="element-1174" data-mp="2qsqp11yqjnt9" />
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1175" data-mp="2mpty8nz1kle8">
                    {coupon.code}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1176" data-mp="2vrtidp5cs5le">
                    {coupon.type}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1177" data-mp="281fzop8nrj3h">
                    {coupon.usage}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1178" data-mp="231l8slovutif">
                    {coupon.amount}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1179" data-mp="bz2rrm1vfa3d">
                    {coupon.expire}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1180" data-mp="gqulu6k8jxy9">
                    {coupon.limitations}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1181" data-mp="3k7b65a1t2q02">
                    {coupon.exceed}
                  </td>
                  <td className="px-3 py-2 text-center" data-id="element-1182" data-mp="3p6xlbp172gbi">
                    <div className="flex items-center justify-center gap-2" data-id="element-1183" data-mp="3u5h4jhoele06">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/coupons/view/${coupon.id}`)} data-id="element-1184" data-mp="3u7liytjxhvep">
                        <Eye className="h-4 w-4" data-id="element-1185" data-mp="1dfk4hz3osula" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/coupons/edit/${coupon.id}`)} data-id="element-1186" data-mp="2xz5nxhjf5a9c">
                        <Edit className="h-4 w-4" data-id="element-1187" data-mp="2p4hm61d1yapa" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1188" data-mp="2k6g49jrd4hfe">
                        <Trash2 className="h-4 w-4" data-id="element-1189" data-mp="2a8jscpqlpig8" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="flex items-center justify-between" data-id="element-1190" data-mp="219om5dnk48cx">
        <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1191" data-mp="4fthzrpgd9ds">
          Delete Selected
        </Button>
        <div className="text-sm text-blue-600 flex items-center gap-1" data-id="element-1192" data-mp="2scjw259cjk50">
          <button className="hover:underline" data-id="element-1193" data-mp="2xb3is7vrkzyf">&lt;&lt; previous</button>
          <span className="text-slate-400" data-id="element-1194" data-mp="2x87lmlrqqfb1">|</span>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n, i) => <Fragment key={n} data-id="element-1195" data-mp="2o9vlnt4zi55x" data-mpi={i}>
              {i > 0 && <span className="text-slate-400" data-id="element-1196" data-mp="2o8ua7nk23gno">|</span>}
              <button className={`hover:underline ${n === 1 ? 'text-slate-900 font-medium' : ''}`} data-id="element-1197" data-mp="29kzerzenyy6w">
                {n}
              </button>
            </Fragment>)}
          <span className="text-slate-400" data-id="element-1198" data-mp="20kkrwvm1xb1a">|</span>
          <button className="hover:underline" data-id="element-1199" data-mp="20lvvaubl4grv">next &gt;&gt;</button>
        </div>
      </div>
    </div>;
}